module.exports = __webpack_public_path__ + "img/resultado4.f64ccbf0.jpg";